module.exports = __webpack_public_path__ + "img/metal_z@2x.eb7bfdbe.png";